export const tableTypeLabel = (type: string): string => {
  switch (type) {
    case 'inventory':
      return 'Inventory';
    case 'project':
      return 'Projects';
    case 'order':
      return 'Orders';
    case 'case':
      return 'Cases';
    case 'related_project_assets':
      return 'Related Inventory';
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Data';
  }
};
